export default __webpack_public_path__ + "static/media/46t.02ac3e28.jpg";